import React from 'react';
import { Box, Typography, Chip, Divider } from '@mui/material';
import { WorkTimeTemplate } from '../../types/workTimeTemplate';

interface TemplatePreviewProps {
  template: WorkTimeTemplate;
}

const TemplatePreview: React.FC<TemplatePreviewProps> = ({ template }) => {
  const formatTime = (date: Date): string => {
    return date.toLocaleTimeString('ko-KR', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: false 
    });
  };

  return (
    <Box
      sx={{
        mt: 2,
        p: 2,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        backgroundColor: 'background.paper',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
          {template.name}
        </Typography>
        <Chip 
          label="읽기 전용" 
          size="small" 
          color="default"
          sx={{ fontSize: '0.7rem', height: '20px' }}
        />
      </Box>
      
      <Divider sx={{ my: 1 }} />
      
      <Box sx={{ mb: 1 }}>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
          근무 시간
        </Typography>
        {template.timeRanges.map((range, index) => (
          <Box key={index} sx={{ mb: 0.5 }}>
            <Typography variant="body2">
              {index + 1}차: {formatTime(range.start)} ~ {formatTime(range.end)}
            </Typography>
          </Box>
        ))}
      </Box>
      
      {template.breakTime && (
        <Box>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
            휴게시간
          </Typography>
          <Typography variant="body2">
            {template.breakTime}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default TemplatePreview;


